import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import { useHistory } from "react-router-dom";
import { useAlert } from "react-alert";
import auth from "../../../core/auth";
const appparameters = require("../../../core/common.jsx");

export const ES = (props) => {
  const alert = useAlert();
  const [loading, setLoading] = useStateIfMounted(false);
  const [state, setState] = useStateIfMounted({
    siteid: props.location.state.siteId,
    location: props.location.state.siteInformation,
    latitude: props.location.state.latitude,
    longitude: props.location.state.longitude,
    description: props.location.state.siteDescription,
    mailonfault: props.location.state.mail,
    index: props.location.state.index,
  });

  const history = useHistory();
  const handleClick = () => history.push("/");

  function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);
    let temp_state = { ...state, ...auth.getUserData() };
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(temp_state),
    };
    //console.log(temp_state);
    fetch(
      appparameters.backend_app_url + "/frontend/changesiteinformation",
      requestOptions
    )
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData) {
          history.push("/grid");
          localStorage.setItem(
            props.mac + "_grid_state",
            JSON.stringify({
              ...state,
              siteInformation: props.location.state.location,
              siteDescription: props.location.state.description,
              latitude: props.location.state.latitude,
              longitude: props.location.state.longitude,
              mail: props.location.state.mailonfault,
            })
          );
          alert.show("Site edited successfully", {
            type: "success",
            position: "middle",
          });
        } else {
          alert.show("Failed to change", { type: "error", position: "middle" });
        }
        setLoading(false);
      });
  }

  useEffect(() => {
    //console.log("state.mailonfault"+state.mailonfault);
  }, []);

  if (loading) {
    return (
      <div className="container">
        <center>
          <img
            src={require("./../../../images/simpleloading.gif")}
            className="simpleloadingview"
          />
          <p>
            <strong>Loading site ...</strong>
            <br />
          </p>
        </center>
      </div>
    );
  } else {
    return (
      <React.Fragment>
        <form className="container" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="col-md-6 mb-3">
              <label>Site ID</label>
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="inputGroupPrepend2">
                    @
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Site id"
                  aria-describedby="inputGroupPrepend2"
                  value={state.siteid}
                  onChange={(e) =>
                    setState({ ...state, siteid: e.target.value })
                  }
                  disabled={true}
                />
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-4 mb-3">
              <label>Location</label>
              <input
                type="text"
                className="form-control"
                placeholder="Site location name"
                value={state.location}
                onChange={(e) =>
                  setState({ ...state, location: e.target.value })
                }
              />
            </div>
            <div className="col-md-4 mb-3">
              <label>Latitude Location (DD)</label>
              <input
                type="number"
                className="form-control"
                placeholder="Site latitude location in decimal degrees (DD)"
                value={state.latitude}
                onChange={(e) =>
                  setState({ ...state, latitude: e.target.value })
                }
              />
            </div>
            <div className="col-md-4 mb-3">
              <label>Longitude Location (DD)</label>
              <input
                type="number"
                className="form-control"
                placeholder="Site longitude location in decimal degrees (DD)"
                value={state.longitude}
                onChange={(e) =>
                  setState({ ...state, longitude: e.target.value })
                }
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-12 mb-3">
              <label htmlFor="inputPassword">Description</label>
              <input
                type="text"
                className="form-control"
                placeholder="Description"
                value={state.description}
                onChange={(e) =>
                  setState({ ...state, description: e.target.value })
                }
              />
            </div>
          </div>
          <div className="form-group">
            <div className="custom-control custom-switch">
              <input
                className="custom-control-input"
                type="checkbox"
                id="addsitecheckbox"
                onChange={() =>
                  setState({
                    ...state,
                    mailonfault: state.mailonfault == 0 ? 1 : 0,
                  })
                }
                checked={state.mailonfault > 0}
              />
              <label className="custom-control-label" htmlFor="addsitecheckbox">
                Sync this site with email
              </label>
            </div>
          </div>
          <div className="alert alert-info" role="alert">
            Latitude and Longitude location parameters for the map view display.
          </div>
          <button className="btn btn-primary" type="submit">
            Change
          </button>
          &nbsp;
          <button
            className="btn btn-secondary"
            type="button"
            onClick={handleClick}
          >
            Cancel
          </button>
        </form>
      </React.Fragment>
    );
  }
};
